export function computeVirtualWindow({ itemCount, scrollTop = 0, viewportHeight = 400, rowHeight = 42, overscan = 8 } = {}) {
  const total = Math.max(0, Number(itemCount) || 0);
  const safeRowHeight = Math.max(1, Number(rowHeight) || 42);
  const visible = Math.ceil(Math.max(0, Number(viewportHeight) || 0) / safeRowHeight);
  const start = Math.max(0, Math.floor(Math.max(0, Number(scrollTop) || 0) / safeRowHeight) - Math.max(0, Number(overscan) || 0));
  const end = Math.min(total, start + visible + Math.max(0, Number(overscan) || 0) * 2);
  return { start, end, topPadding: start * safeRowHeight, bottomPadding: Math.max(0, total - end) * safeRowHeight };
}
